module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='\n<!-- src/app/employer/templates/settings/PositionItem.ejs -->\n<td class="td-nowrap">\n    <div class="form-control form-control-with-delete">\n        <span class="form-control-value"></span>\n\n        <input name="name"\n            class="form-control form-control-invisible"\n            type="text" autocomplete="off"\n            value="'+
((__t=( model.get('name') ))==null?'':_.escape(__t))+
'">\n\n        <a class="form-control-delete fa fa-times btn-delete js-destroy"\n            tabindex="-1"></a>\n    </div>\n    <div class="error error-name"></div>\n    <div class="error error-name error-placeholder"></div>\n</td>\n';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./app/employer/templates/settings/PositionItem.ejs
// module id = 848
// module chunks = 1